/**
 * 체불업체(비회원) 정정 요청 — JS 클라 렌더 SPA
 * 시안 출처: uSpec-custom/references/9_somyung_20260618/source/somyung.html (소명 트랙은 2026-10 폐지, 정정만 남김)
 *
 * 진입: /b/d/{token} 셸이 #page-data(JSON)로 부트 컨피그 주입.
 *   boot 구조: {invalid?, message?, demo?, token, report:{...}, state, reportStatus, verified?, ...}
 *
 * 화면: auth_first(안내) → auth_return(본인인증) → notme(정정 요청서 BS)
 *   → notme_done(접수) · notme_rejected(반려) · notme_approved(처리) · registered(기한 만료) · recalled(신고 철회)
 *
 * 셸 ID: #b-defense > #dv-nav-bar + #dv-frame > #dv-app  (defense.blade.php)
 */
import { makeComponents } from './Defense/components';
import { makeScreens } from './Defense/screens';
import { showToast, showOv, showLoading, showPhotoGallery, openPhotoUpload } from './Defense/UiHelpers';
import { makeStore } from './Defense/Store';
import { makeAuth } from './Defense/AuthSheet';
import { makeNotmeForm } from './Defense/NotmeForm';
import Util from '../../Common/Util';
export default class Defense {
    initialize() {
        this.boot  = JSON.parse(document.getElementById('page-data')?.textContent || '{}');
        this.$root = $('#b-defense');
        if (this.boot.invalid) {
            this.renderInvalid(this.boot.message || '유효하지 않거나 만료된 링크입니다.');
            return;
        }
        if (this.boot.demo) this.$root.addClass('dv-demo');
        this._spaInit();
    }

    renderInvalid(msg) {
        $('#dv-app').html(`
          <div class="scr fi">
            <div class="hdr"><div style="width:32px"></div><span class="hdr-t">접속 불가</span><div style="width:32px"></div></div>
            <div style="flex:1;display:flex;align-items:center;justify-content:center;padding:24px;text-align:center">
              <p style="font-size:15px;color:var(--t2);line-height:1.7">${$('<div>').text(msg).html()}</p>
            </div>
          </div>`);
    }

    _spaInit() {
        const self = this;

        // ────────────────────────────────────────────────────────────────
        // 상태/헬퍼 — Store 모듈로 일원화 (상태 S + boot매핑 + 마감일/LS/stateToScreen/applyLoad)
        // ────────────────────────────────────────────────────────────────
        const store = makeStore(self.boot);
        const S = self.S = store.S;
        const { getDeadlineRemaining, saveLastScreen, loadLastScreen, stateToScreen, applyLoad } = store;

        // (분리) SVG 아이콘 → Defense/icons.js (화면 모듈 screens.js 에서 import).
        // ────────────────────────────────────────────────────────────────
        // 토스트 / 오버레이 / 로딩 / 사진 갤러리 — 시안 그대로 ($('#app') → $('#dv-app'), $('#frame') → $('#dv-frame'))
        // ────────────────────────────────────────────────────────────────
        // (분리) UI 헬퍼 → Defense/UiHelpers.js — showToast/showOv/showLoading/showPhotoGallery/openPhotoUpload.
        //   showOv: 공용 $j.Ui.BS shim(onBind: find/remove). BS는 <body> 렌더라 콘텐츠에 .dv-scope 직접 부여.

        // (분리) showPhotoGallery → Defense/UiHelpers.js

        // 마스킹은 서버(DvMask)에서 처리 후 내려준다 — 클라이언트 마스킹 금지(명세 3장).

        // (분리) 공용 컴포넌트(header/urgencyBanner/reportTable/faqSection) → Defense/components.js.

        // ────────────────────────────────────────────────────────────────
        // 증빙사진 업로드 — 공용 $j.F.Upload (제보 화면과 동일 패턴).
        //   + 버튼 → addPhotoHere(context, url=게스트 엔드포인트) → 완료 시 EventBus 'upload:image'.
        //   서버 응답 {id, path, host} → {id, url}. context 'defenseNotme' 만 받아 누적(최대 10장) 후 폼 BS 재렌더.
        //   (등록은 _spaInit 1회 — bind() 마다 재등록하지 않음)
        // ────────────────────────────────────────────────────────────────
        $j.Common.EventBus.on($j.getNS(self), 'upload:image', (e, payload) => {
            if ($j.F.Upload.getContext() !== 'defenseNotme') return;   // 정정 화면 외 업로드는 무시
            const target = S.notmePhotos;
            (Array.isArray(payload) ? payload : [payload]).forEach((file) => {
                if (!file || !file.id || target.length >= 10) return;
                target.push({ id: file.id, url: file.host ? Util.getImageUrl(file.path, file.host, 'original') : '' });
            });
            notmeForm.rerender();
        });

        // (분리) openPhotoUpload → Defense/UiHelpers.js

        // (분리) 상태 S + boot 매핑 → Defense/Store.js (makeStore, 위에서 생성)

        // (분리) 컴포넌트·화면 모듈 (Defense/ 폴더) — 본문 동일, 클로저 상태 S·헬퍼만 주입.
        const C = makeComponents(S, getDeadlineRemaining);
        const { header, urgencyBanner, faqSection, reportTable } = C;
        const {
            _stubScr, rAuthFirst, rAuthReturn, rAuthFormInner,
            rNotMeDone, rNotMeApproved, rNotMeRejected, rRegistered, rRecalled,
        } = makeScreens(S, C);
        // (정정폼은 BS 모듈(NotmeForm)이 렌더)

        const SC = {
            auth_first:          rAuthFirst,
            auth_return:         rAuthReturn,
            notme_done:          rNotMeDone,
            notme_approved:      rNotMeApproved,
            notme_rejected:      rNotMeRejected,
            registered:          rRegistered,
            recalled:            rRecalled,
        };

        // ────────────────────────────────────────────────────────────────
        // 화면 전환
        // ────────────────────────────────────────────────────────────────
        function go(scr) {
            // 정정폼: auth_first 를 base 로 깔고 정정폼 BS 오픈 (full 화면 대체)
            if (scr === 'notme') {
                S.scr = 'auth_first'; saveLastScreen();
                $('#dv-app').html(SC.auth_first());
                bind();
                uNav();
                notmeForm.openSheet();
                return;
            }
            S.scr = scr;
            saveLastScreen();
            $('#dv-app').html((SC[scr] || rAuthFirst)());
            bind();
            uNav();
        }
        function uNav() {
            $('.nb:not(.nb-demo)').each(function () {
                $(this).toggleClass('on', $(this).attr('data-s') === S.scr);
            });
        }
        function rr() {
            const $oldScr = $('.scr .noscr');
            const scrollTop = $oldScr.length ? $oldScr.scrollTop() : 0;
            $('#dv-app').html((SC[S.scr] || rAuthFirst)());
            bind();
            if (scrollTop > 0) {
                const $newScr = $('.scr .noscr');
                $newScr.scrollTop(scrollTop);
                requestAnimationFrame(() => $newScr.scrollTop(scrollTop));
            }
        }

        // ────────────────────────────────────────────────────────────────
        // SMS 본인 인증 — Defense/AuthSheet.js 로 분리 (full 화면·바텀시트 공용)
        //   authSuccessGo / bindAuthHandlers(onSuccess) / openAuthSheet
        // ────────────────────────────────────────────────────────────────
        // ────────────────────────────────────────────────────────────────
        // ① 소명 — 제보자와 통화 시트 (안심번호). [전화 걸기] → POST /b/defense/ajax/call/connect → tel: 발신.
        //   서버가 문자 본인인증(SESS_SMS_OK)을 확인하므로 인증 전엔 호출하지 않는다(bind 의 .call-reg-btn 분기).
        //   회원 앱의 제보자 통화(F/Devil/Render.js _openConnectModal)와 같은 패턴: busy 가드 + 시트 안 오류 + tel: 이동.
        // ────────────────────────────────────────────────────────────────
        function openCallSheet() {
            showOv('제보자에게 전화 연결',
                `<div style="text-align:center;padding:14px 0">
                  <div style="width:56px;height:56px;border-radius:28px;background:var(--Cg);display:flex;align-items:center;justify-content:center;margin:0 auto 12px">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6A19.79 19.79 0 012.12 4.18 2 2 0 014.11 2h3a2 2 0 012 1.72c.127.96.362 1.903.7 2.81a2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.338 1.85.573 2.81.7A2 2 0 0122 16.92z" stroke="var(--C)" stroke-width="2"/></svg>
                  </div>
                  <p style="font-size:13px;color:var(--t3);line-height:1.7">안심번호로 연결됩니다.<br><span style="color:var(--t2)">상대방의 실제 번호는 노출되지 않습니다.</span></p>
                </div>
                <p class="ov-call-err" style="display:none;font-size:12px;color:var(--R);text-align:center;margin:0 0 8px"></p>
                <button class="ov-call-go btn-act btn-act-fill">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none"><path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6A19.79 19.79 0 012.12 4.18 2 2 0 014.11 2h3a2 2 0 012 1.72c.127.96.362 1.903.7 2.81a2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.338 1.85.573 2.81.7A2 2 0 0122 16.92z" stroke="var(--on-brand)" stroke-width="2"/></svg>
                  전화 걸기
                </button>`,
                ov => ov.find('.ov-call-go').on('click', function () {
                    const $go  = $(this);
                    const $err = ov.find('.ov-call-err');
                    if ($go.data('busy')) return;
                    $go.data('busy', true).css('opacity', .6);
                    $err.hide().text('');
                    const showErr = (msg) => {
                        $err.text(msg || '안심번호 연결에 실패했습니다.').show();
                        $go.data('busy', false).css('opacity', 1);
                    };
                    $.ajax({ url: '/b/defense/ajax/call/connect', type: 'POST', dataType: 'json' })
                        .done((res) => {
                            if (res && res.result && res.virtual_number) {
                                ov.remove();
                                location.href = 'tel:' + res.virtual_number;   // 서버가 준 가상번호로 발신 — 실번호는 클라에 오지 않는다
                                return;
                            }
                            showErr(res && res.message);
                        })
                        .fail((xhr) => showErr(xhr && xhr.responseJSON && xhr.responseJSON.message));
                })
            );
        }

        const { authSuccessGo, bindAuthHandlers, openAuthSheet } = makeAuth({ S, boot: self.boot, go, stateToScreen, rAuthFormInner, openCallSheet });

        // ────────────────────────────────────────────────────────────────
        // 화면단위 폼 모듈 (BS) — Defense/NotmeForm.js (정정 요청서)
        //   _activeForm: 현재 열린 폼 BS 종류('notme'|null). BS 가 닫히면 EventBus 'BS:close' 로 리셋.
        // ────────────────────────────────────────────────────────────────
        let _activeForm = null;
        const setActiveForm = (v) => { _activeForm = v; };
        const notmeForm = makeNotmeForm({ S, go, setActiveForm });
        $j.Common.EventBus.on($j.getNS(self), 'BS:close', () => { _activeForm = null; });

        // ────────────────────────────────────────────────────────────────
        // 유효성 / 제출 버튼 활성화
        // ────────────────────────────────────────────────────────────────
        // (분리) 제출 버튼 활성화 → 폼 모듈(NotmeForm)의 updateBtn 이 자체 처리

        // ────────────────────────────────────────────────────────────────
        // 이벤트 바인딩 — go(scr) / rr() 매 호출마다 재실행
        // 시안 그대로 (uSpec source L1158-1485)
        // ────────────────────────────────────────────────────────────────
        function bind() {
            const s = S.scr;

            // 헤더 X 버튼 — 카카오톡으로 돌아가기(페이지 닫기)
            //   카카오톡 인앱브라우저/스크립트로 연 창: window.close() 로 닫힘.
            //   사용자가 직접 연 일반 탭: 브라우저 보안상 close() 가 무시될 수 있음(닫기 불가).
            $(document).off('click.kkback').on('click.kkback', '[data-act="kk-back"]', () => {
                window.close();
            });

            // FAQ 아코디언 mutex - 1개 펼치면 다른 건 닫힘
            $(document).off('click.faq').on('click.faq', '.faq-item > summary', function (e) {
                e.preventDefault();
                const $details = $(this).parent();
                const wasOpen = $details.prop('open');
                $('.faq-item').each(function () { this.open = false; });
                if (!wasOpen) $details.prop('open', true);
            });

            // 개인정보 활용 동의 시트는 폼(NotmeForm)이 동의 행 클릭에서 UiHelpers.openPrivacyConsent 로 연다
            //   (구 '자세히 보기' 위임 핸들러는 2026-09-18 제보 화면과 같은 '끝까지 읽어야 동의' 흐름으로 바꾸며 제거).

            // ① 소명 — 제보자와 통화. 문자 본인인증 전이면 인증 시트부터(S.afterAuth='call' → AuthSheet.authSuccessGo 가 통화 시트를 연다),
            //   통과했으면 바로 통화 시트(안심번호 발급 → tel:).
            $('.call-reg-btn').on('click', function () {
                if (!S.smsOk) { S.afterAuth = 'call'; openAuthSheet(); return; }
                openCallSheet();
            });

            // 증빙 자료(요청자 업로드) 썸네일 → 갤러리 (삭제 버튼 제외). 제보자 증빙사진은 이 페이지에 안 내려온다
            $(document).off('click.phzoom').on('click.phzoom', '.ph-thumb', function (e) {
                if ($(e.target).closest('.ph-del').length) return;
                const i = +$(this).data('pi');
                const arr = S.notmePhotos;
                // 공유 컴포넌트 $j.Ui.ZoomPhoto 로 전체화면 뷰(줌·스와이프). 삭제는 기존 썸네일 X 유지.
                $j.Ui.ZoomPhoto.open(null, { items: arr.map(p => ({ url: p.url })), index: i });
            });

            // 일반 아코디언 (.acc)
            $('.acc-hdr').on('click', function () { $(this).parent().toggleClass('open'); });

            // ──────── 화면별 핸들러 ────────

            // 첫 접속 — ② 정정 요청하기 → 본인인증(바텀시트) → 정정 요청서. 이미 문자 인증을 통과한 세션이면 시트 생략.
            if (s === 'auth_first') {
                $('#go-notme').on('click', function () {
                    S.afterAuth = 'notme';
                    if (S.smsOk) { authSuccessGo(); return; }
                    openAuthSheet();
                });
            }

            // SMS 본인 인증 (full 화면 — 재접속 게이트). 핸들러는 공용 bindAuthHandlers 사용.
            if (s === 'auth_return') {
                bindAuthHandlers(authSuccessGo);
            }

            // (분리) 정정폼 로직 → Defense/NotmeForm.js — go('notme') 가 폼 BS 를 연다.
            // 반려(notme_rejected) 화면에 재요청 버튼은 없다 — 재제출 불허(기획 2026-10-01), 담당자가 전화로 안내.
        }

        // ────────────────────────────────────────────────────────────────
        // 데모 네비게이션 (?demo=1) — 화면 점프 버튼
        // ────────────────────────────────────────────────────────────────
        // P1-3: 시안 source navItems 라벨 그대로 (README.md 화면 인덱스와 일관)
        const navItems = [
            { grp: '공통' },
            { s: 'auth_first',          t: '1. 소명 기회 안내' },
            { s: 'auth_return',         t: '2. 본인 인증' },
            { divider: true },
            { grpB: '정정 요청' },
            { s: 'notme',               t: '3. 정정 요청서' },
            { s: 'notme_done',          t: '4. 접수 완료' },
            { s: 'notme_rejected',      t: '4-1. 반려' },
            { s: 'notme_approved',      t: '5. 처리 완료' },
            { divider: true },
            { grp: '종단' },
            { s: 'registered',          t: '6. 기한 만료 → 등록' },
            { s: 'recalled',            t: '7. 제보 철회' },
        ];
        if (self.boot.demo) {
            const navHtml = navItems.map(it => {
                if (it.divider) return '<div class="nb-divider"></div>';
                if (it.grp)     return `<button class="nb-grp">${it.grp}</button>`;
                if (it.grpB)    return `<button class="nb-grp nb-grp-b">${it.grpB}</button>`;
                return `<button class="nb" data-s="${it.s}">${it.t}</button>`;
            }).join('');
            $('#dv-nav-bar').html(navHtml).on('click', '.nb:not(.nb-grp)', function () {
                const s = $(this).attr('data-s');
                if (s) go(s);
            });
        }

        // ────────────────────────────────────────────────────────────────
        // urgencyBanner 30초마다 갱신
        // ────────────────────────────────────────────────────────────────
        self._urgencyTimer = setInterval(() => {
            const $b = $('#dv-app .urgency-banner');
            if ($b.length) $b.replaceWith(urgencyBanner());
        }, 30000);

        // (분리) stateToScreen / applyLoad → Defense/Store.js (makeStore)

        // ────────────────────────────────────────────────────────────────
        // 진입 — 우선순위: ?scr= URL 강제(dev) > 서버 상태(boot.state) > 마지막 화면(demo) > auth_first
        //   서버 상태 진입 화면이 인증 필요(AUTH_REQUIRED)인데 30분 SMS 세션 만료면 auth_return 으로 게이트.
        // ────────────────────────────────────────────────────────────────
        const SESSION_MS = 30 * 60 * 1000;
        const AUTH_REQUIRED = [
            'notme', 'notme_done', 'notme_approved', 'notme_rejected', 'registered', 'recalled',
        ];
        // ?scr= 는 서버 토글(boot.allowScrParam)이 true 일 때만 처리. 운영에선 false → 무시.
        const urlScrRaw = new URLSearchParams(location.search).get('scr');
        const urlScr    = self.boot.allowScrParam ? urlScrRaw : null;
        if (urlScrRaw && !self.boot.allowScrParam) {
            console.warn('[Defense] ?scr= 무시됨 — 운영 환경에서는 허용되지 않습니다.');
        }
        const lastScr = loadLastScreen();
        const sessionValid = S.authVerified && S.authVerifiedAt && (Date.now() - S.authVerifiedAt) < SESSION_MS;
        let startScr = 'auth_first';
        if (urlScr && SC[urlScr]) {
            console.log(`[Defense] ?scr=${urlScr} — 강제 화면 진입 (dev/QA 용, 인증 게이트 우회)`);
            startScr = urlScr;
        } else if (String(self.boot.reportStatus || '').toUpperCase() === 'RECALLED') {
            // 신고가 철회된 건 — 정정 상태와 무관하게 철회 종단 화면 (철회 안내 문자의 링크)
            startScr = sessionValid ? 'recalled' : 'auth_return';
        } else if (self.boot.state) {
            // 실서비스 — 서버 정정 상태(defense_status)로 진입 화면 결정
            startScr = stateToScreen(self.boot.state);
            if (AUTH_REQUIRED.includes(startScr) && !sessionValid) startScr = 'auth_return';
        } else if (lastScr && SC[lastScr]) {
            // demo/폴백 — 마지막 화면 복원
            startScr = (AUTH_REQUIRED.includes(lastScr) && !sessionValid) ? 'auth_return' : lastScr;
        }

        // 실서비스(데모·?scr= dev 아님): 서버 데이터 load 후 진입 — 재접속 시 진행화면 복원.
        if (self.boot.demo || urlScr) {
            go(startScr);
        } else {
            const ld = showLoading('불러오는 중...');
            $.ajax({ url: '/b/defense/ajax/load', type: 'GET', dataType: 'json' })
                .done((res) => {
                    if (res && res.result && res.verified !== false) applyLoad(res);
                    ld.remove();
                    go(startScr);
                })
                .fail(() => { ld.remove(); go(startScr); });
        }

        // 외부 접근용
        self._spa = { go, rr, S, SC, showOv, showLoading, showToast, showPhotoGallery, urgencyBanner };
    }

    /**
     * 페이지 파기 시 정리 ($j.destroy / 페이지 이탈) — 누수 방지 (관례: BS·Admin 모듈과 동일).
     *   urgency/auth 타이머 + EventBus 네임스페이스(upload:image·BS:close) + document 위임 핸들러 + 열린 BS 정리.
     *   모두 무해 연산 — 대상 없으면 no-op (평소 동작엔 영향 없음, 파기 시에만 실행).
     */
    destroy() {
        if (this._urgencyTimer) clearInterval(this._urgencyTimer);
        if (window._authTimer) { clearInterval(window._authTimer); window._authTimer = null; }
        $(document).off('.kkback .faq .privacy .proof .phzoom .nmfdel .pg');
        if ($j.Common && $j.Common.EventBus) $j.Common.EventBus.offNamespace($j.getNS(this));
        try { $j.Ui.BS.close(); } catch (e) {}
    }
}
